<div class="pairings-alpha-list">
  @if (isLoading) {
    <div class="text-center text-muted m-t-sm m-b-sm">
      Loading alphabetical view...
    </div>
  } @else if (players.length) {
    <div class="table-responsive">
      <table class="table table-striped table-hover table-condensed">
        <thead>
          <tr>
            <th>#</th>
            <th>Player</th>
            <th>Grp</th>
            <th>Tee</th>
            <th>Tee Time</th>
            @if (showWaveColumn) {
              <th>Wave</th>
            }
            @if (showBlockColumn) {
              <th>Block</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (player of players; track player.id; let index = $index) {
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <div class="player-name">{{ player.playerName }}</div>
                @if (player.classification) {
                  <span class="label label-default">{{ player.classification }}</span>
                }
              </td>
              <td>{{ player.groupLabel }}</td>
              <td>{{ player.teeLabel }}</td>
              <td>{{ player.teeTimeDisplay }}</td>
              @if (showWaveColumn) {
                <td>{{ player.waveLabel || '—' }}</td>
              }
              @if (showBlockColumn) {
                <td>{{ player.blockLabel || '—' }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else if (hasBlocks) {
    <div class="text-muted m-t-sm">
      No players found for alphabetical view.
    </div>
  } @else {
    <div class="text-muted m-t-sm">
      Generate pairings to view the alphabetical list of players.
    </div>
  }
</div>
